module.exports = __webpack_public_path__ + "img/honors_2023.e79b43ce.png";